
import { ErrorDto, FlyerDto, FlyerType, GuiSettingsDto, LanguageCulture } from '../../dtos';
import * as Globals from '../../globals/index';

import { Action } from '../actions/guiSettingsActions';
import { ActionType } from '../actionTypes';

export interface GuiSettingsState {
    guiSettings: GuiSettingsDto[];
    currentGuiSettingsDto: GuiSettingsDto;

    loading?: boolean;
    error?: ErrorDto | null;
}

export class GuiSettingsInitialState implements GuiSettingsState {
    guiSettings = [];
    currentGuiSettingsDto = new GuiSettingsDto();

    loading = false;
    error = null;
}


const initialState = new GuiSettingsInitialState();

const reducer = (state: GuiSettingsState = initialState, action: Action) : GuiSettingsState  => {

    switch(action.type)
    {
        // get
        case ActionType.GET_GUI_SETTINGS_START:
            return { ...state, error: null, loading: true};

        case ActionType.GET_GUI_SETTINGS_SUCCESS:
            return { 
                guiSettings: [ ...action.payload ], 
                currentGuiSettingsDto: new GuiSettingsDto(),
                error: null, 
                loading: false 
            };

        case ActionType.GET_GUI_SETTINGS_ERROR:
            return { ...state, error: action.payload, loading: false};

        case ActionType.GET_GUI_SETTINGS_COMPLETED:
            return { ...state, error: null, loading: false};


        // Save
        case ActionType.PUT_GUI_SETTINGS_START:
            return { ...state, error: null, loading: true};

        case ActionType.PUT_GUI_SETTINGS_SUCCESS:
            return { 
                guiSettings: [ ...action.payload.guiSettingsDtos ], 
                currentGuiSettingsDto: { ...action.payload.currentGuiSettingsDto },
                error: null, 
                loading: false 
            };

        case ActionType.PUT_GUI_SETTINGS_ERROR:
            return { ...state, error: action.payload, loading: false};

        case ActionType.PUT_GUI_SETTINGS_COMPLETED:
            return { ...state, error: null, loading: false};

        // Delete
        case ActionType.DELETE_GUI_SETTINGS_START:
            return { ...state, error: null, loading: true};

        case ActionType.DELETE_GUI_SETTINGS_SUCCESS:
            return { 
                guiSettings: [ ...action.payload ],
                currentGuiSettingsDto: new GuiSettingsDto(),
                error: null, 
                loading: false 
            };

        case ActionType.DELETE_GUI_SETTINGS_ERROR:
            return { ...state, error: action.payload, loading: false};

        case ActionType.DELETE_GUI_SETTINGS_COMPLETED:
            return { ...state, error: null, loading: false};

        default:
            return state;
    }
}

export default reducer;